<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
  // 全局引用字体图标iconfont
  import './assets/font/iconfont/iconfont.css';

export default {
  name: 'App'
}
</script>
<style lang="scss">
  @import "assets/css/style.scss";
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  overflow-y: hidden;
/*  text-align: center;
  color: #2c3e50;
  margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue